import { render } from "./subscribedcompaniesmodal.vue?vue&type=template&id=6656369d"
import script from "./subscribedcompaniesmodal.vue?vue&type=script&lang=js"
export * from "./subscribedcompaniesmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__